import React, { useRef, useState, useEffect } from "react";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import Slider from "react-slick";
import "./css/PopularLocation.css";
import locations from "../data/trips"


export default function PopularLocations() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const sliderRef = useRef(null);
  const renderStars = (count) => {
    return "★".repeat(count) + "☆".repeat(5 - count);
  };
  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: windowWidth < 600 ? 1 : windowWidth < 1024 ? 2 : 4,
    slidesToScroll: 1,
    autoplay: true, // manual only
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } }
    ]
  };

  return (
    <div className="popular-locations container">
           

      <Slider ref={sliderRef} {...settings}>
        {locations.slice(0, 6).map((loc, index) => (
          <div key={index} className="location-card">
            <div className="image-wrapper">
              <LazyLoadImage
                            alt="{loc.name}"
                            src={loc.image}
                            effect="blur"
                          />
              <div className="bg-drk"></div>
              <div className="overlay">
                <h3>{loc.name}</h3>
                <div>
                    <p>{renderStars(loc.rating)}</p>
                </div>
                <a href={`/explore/${loc.name}`} className="btn-bl" >Book Now</a>
              </div>
            </div>
          </div>
        ))}
      </Slider>
      <div className="slider-controls">
        <button onClick={() => sliderRef.current.slickPrev()} className="nav-btn">← Prev</button>
        <button onClick={() => sliderRef.current.slickNext()} className="nav-btn">Next →</button>
      </div>
    </div>
  );
}
